<template>

    <span class="btn_circle_icon">
        <i :class="icon"></i>
    </span>

</template>

<script>
export default {
    name: 'btnCircleIcon',
    props: ['icon']
  }

</script>

<style lang="scss" scoped>
.btn_circle_icon{
    user-select: none;
    background: $info;
    color: $white;
    border-radius: 100%;
    height:32px;
    width:32px;
    line-height: 34px;
    display: inline-block;
    text-align: center;
    margin: 0 12px;
    transition: .3s all;
    cursor: pointer;
    &.large{
        height:64px;
        width:64px;
        line-height: 68px;
        font-size: 1.5rem;
    }
    &.disabled{
        background: $grey-light;
    }
}
</style>